import { MenuItem as MuiMenuItem, MenuItemProps, styled } from '@mui/material'

export const MenuOption = styled(MuiMenuItem)<MenuItemProps>(({ theme }) => ({
  boxSizing: 'border-box',
  overflowX: 'hidden',
  padding: theme.spacing(1, 2),

  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  whiteSpace: 'normal',
  ...theme.typography.caption1,

  '&:hover': {
    background: theme.palette.primary.light,
  },

  '&.Mui-focusVisible': {
    background: theme.palette.primary.light,
  },

  '&.Mui-selected, &[aria-selected="true"]': {
    background: theme.palette.primary.light,
  },

  '&.Mui-disabled': {
    opacity: 1,
    background: theme.palette.alabaster,
    color: theme.palette.text.secondary,
  },
}))
